export default "__VITE_ASSET__8Sj4ECOk__"